import { formatDate } from "../../../../../core/utils/common"

export const parseFiatAccountDetails = (fiatAccount) => {
    if (!fiatAccount) return []

    return [
        {
            key: 'Account ID',
            value: fiatAccount.accountId,
        },
        {
            key: 'Account Type',
            value: fiatAccount.meta?.type,
        },
        {
            key: 'Full Name',
            value: fiatAccount.meta?.name,
        },
        {
            key: 'Email',
            value: fiatAccount.meta?.email,
        },
        {
            key: 'Country',
            value: fiatAccount.meta?.country,
        },
        {
            key: 'Category',
            value: fiatAccount.meta?.category,
        },
        {
            key: 'Status',
            value: fiatAccount.meta?.status,
        },
        {
            key: 'KYC Status',
            value: fiatAccount.meta?.kyc?.status,
        },
        {
            key: 'TOS Status',
            value: fiatAccount.meta?.tos?.status,
        },
        {
            key: 'TOS Result',
            value: fiatAccount.tos,
        },
        {
            key: 'KYC Result',
            value: fiatAccount.kyc?.status || fiatAccount.kyc,
        },
        {
            key: 'First Name',
            value: fiatAccount.user?.firstName,
        },
        {
            key: 'Last Name',
            value: fiatAccount.user?.lastName,
        },
        {
            key: 'User Email',
            value: fiatAccount.user?.email,
        },
        {
            key: 'Verified At',
            value: fiatAccount.user?.verifyAt,
        },
    ].filter((item) => item.value)
}

export const parseRFIData = (RFIData) => {
    const rfi = RFIData?.data?.[0]

    if (!rfi) return []

    const submission = rfi.submission
    const subject = submission?.subject
    const basicInfo = subject?.basicInfo

    const details = [
        {
            key: 'RFI ID',
            value: rfi.id,
        },
        {
            key: 'RFI Kind',
            value: rfi.kind,
        },
        {
            key: 'RFI Status',
            value: rfi.status,
        },
        {
            key: 'Preset',
            value: rfi.presetCode,
        },
        {
            key: 'Submission ID',
            value: rfi.submissionId,
        },
        {
            key: 'Submission Status',
            value: submission?.status,
        },
        {
            key: 'First Name',
            value: basicInfo?.firstName,
        },
        {
            key: 'Last Name',
            value: basicInfo?.lastName,
        },
        {
            key: 'Date of Birth',
            value: basicInfo?.dob,
        },
        {
            key: 'Residence Country',
            value: subject?.residenceCountry,
        },
        {
            key: 'Subject Type',
            value: subject?.type,
        },
        {
            key: 'Created At',
            value: rfi.createdAt
                ? formatDate(rfi.createdAt, 'date')
                : null,
        },
    ]

    /*
     * Questionnaire Answers
     *
     * The API returns:
     * submission.questionnaires[].answers[]
     */
    submission?.questionnaires?.forEach((questionnaire) => {
        questionnaire?.answers?.forEach((answer) => {
            if (!answer?.value) return

            details.push({
                key: answer.id,
                value: formatRFIValue(answer.value),
            })
        })
    })

    /*
     * Documents
     *
     * The API returns:
     * submission.documents[]
     */
    submission?.documents?.forEach((document, index) => {
        if (!document) return

        details.push({
            key: `Document ${index + 1}`,
            value: [
                document.filename,
                document.type,
                document.issuingCountry,
            ]
                .filter(Boolean)
                .join(' - '),
        })
    })

    return details.filter((item) => item.value)
}

const formatRFIValue = (value) => {
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No'
    }

    if (Array.isArray(value)) {
        return value.join(', ')
    }

    if (typeof value === 'object' && value !== null) {
        return JSON.stringify(value)
    }

    return value
}

export const flattenLatestStatus = (data, prefix = '') => {

    if (!data || typeof data !== 'object') {
        return []
    }

    return Object.entries(data).flatMap(([key, value]) => {
        const fullKey = prefix ? `${prefix}.${key}` : key

        if (value == null) return []

        if (Array.isArray(value)) {
            if (!value.length) return []

            return value.flatMap((item, index) =>
                flattenLatestStatus(item, `${fullKey}`)
            )
        }

        if (typeof value === 'object') {
            return flattenLatestStatus(value, fullKey)
        }

        return [{ key: fullKey, value }]
    })
}